module.exports = __webpack_public_path__ + "static/img/background_sebastian_final_ipad_landscape_1024x768_cat620x476_op85.743ab9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/background_sebastian_final_ipad_landscape_1024x768_cat620x476_op85.jpg
// module id = Mji3
// module chunks = 0